import Firebase from "firebase";
import triggerHaptics, {FeedbackMessage, HapticType} from "./triggerHaptics";

const refreshData = async (userID: string, refreshTypes: string[]) => {

    let myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    let firebaseToken = await Firebase.auth().currentUser.getIdToken();

    let raw = JSON.stringify({"uid": userID ,"itemsToRefresh": refreshTypes});

    let requestOptions = {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization':  `Bearer ${firebaseToken}`
        },
        body: raw,
    };

    try {
        let resp = await fetch('https://jaspercardws2.manhattan.edu:7443/api/refreshWithToken', requestOptions);

        let respData = await resp.json();

        if (resp.ok) {
            let state = true;
            let data: any = respData;

            if (!respData || respData.error)
                state = false;

            if (window.webkit)
                triggerHaptics(HapticType.FeedBack, state ? FeedbackMessage.Success : FeedbackMessage.Error);

            if (state)
                return;

            return {error: "Failed. Please try again!"};
        }

        return;
    } catch(error) {
            return {error};
    }
};

export default refreshData;